import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import ImgUrl from "assets/images/qs.png";
import { pageMenuTabList04 } from "types/common";

import "assets/css/research.scss";

const Qs = () => {
  const { researchId } = useParams<{ researchId: string }>();
  pageMenuTabList04[2].on = true;


  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/qualitysystem-hero_1920x1080.jpg.jpg" imgText="품질안전관리" textcolor="#FFF"/>
      <PageTab props={pageMenuTabList04} />
      <div className="container">

        <div className="container-title">
          천호엔케어는 내 가족이 먹는다는 생각으로 제품을 만듭니다.<br/>
          <span className="highlight">원료 수배부터 입고, 보관, 원료의 품질검수까지</span><br/>
          여러차례 철저히 확인하고 관리합니다.
        </div>
        
        <div className="container-item">
          <div className="container-item-title">원료관리 단계</div>
          <div className='container-img-grid col3'>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-01_400x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  1. 원료 입고
                </div>
              </div>
              <div className="img-text">
                품질 좋은 원료 수배를 위해 전세계를 누빕니다.
                믿을 수 있는 원료사에서 검증된
                원료만을 입고합니다.
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-02_400x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  2. 원료 품질 검수
                </div>
              </div>
              <div className="img-text">
                입고된 원료는 철저한 품질 검수를 통해
                다시한번 선별작업을 거칩니다.
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-03_400x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  3. 원료 보관
                </div>
              </div>
              <div className="img-text">
                원료별 특성에 따라 최적화된 보관실에 보관하며 정기적으로 상태 확인을 합니다.
              </div>
            </div>
          </div>
        </div>
        <div className="container-item">
          <div className="container-item-title">원료농장</div>
          <div className="container-item-desc">
            천호엔케어는 품질이 뛰어나고 안전한 원료를 확보하기 위해 생산지 계약 농장 체계를 구축했습니다.
          </div>
          <div className='container-img-grid col2'>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-04_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  강원도 인삼 농장
                </div>
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-05_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  뉴질랜드 녹용 농장
                </div>
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-06_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  지리산 흑염소 농장
                </div>
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-07_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  강화도 사자발쑥 농장
                </div>
              </div>  
            </div>
          </div>
        </div>

        <div className="container-item">
          <div className="container-item-title">품질보증 시스템</div>
          <div className="container-item-desc">
            원료와 부자재는 물론 생산과정과 완제품까지 전과정에 걸쳐 철저한 품질관리를 진행합니다.
          </div>
          <div className='container-img-grid col2'>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-08_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  원/부자재 검수
                </div>
              </div>
              <div className="img-text">
                철저한 품질검수 과정을 통해 규격에 적합한 원/부자재만 사용되고 있으며, 관련 법적서류 확인 등을 통해 안전성을 확보하고 있습니다.
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-09_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  원료 진위판별 검사
                </div>
              </div>
              <div className="img-text">
                원료 진위판별을 위한 유전자 분석방법 지침서(식약처)에 준하여 사용되는 원료의 진위판별을 진행하고 있습니다.
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-10_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  공정위생(미생물) 강화
                </div>
              </div>
              <div className="img-text">
                작업장, 작업자, 작업도구, 압축공기, 용수 및 부자재에 대하여 주기적으로 공정위생(미생물) 검사를 진행함으로 잠재적인 위해요소 제거를 위해 최선을 다 하고 있습니다.
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-11_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  자가품질 검사
                </div>
              </div>
              <div className="img-text">
                생산된 완제품은 매 LOT 자가품질검사 진행하고 있으며,식약처 통합실험정보관리시스템(LIMS)을 통해 성적서를 발행하고 있습니다.
              </div>
            </div>
          </div>
        </div>

        <div className="container-item">
          <div className="container-item-title">이력공개시스템(CRTS)</div>
          <div className="container-item-desc">
            고객님이 더 안심하고 드실 수 있도록 검사자 실명을 기재한 검사성적서를 공개합니다.
          </div>
          <div className='container-img-grid col2'>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-12_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  제품 이력 확인
                </div>
              </div>
              <div className="img-text">
                제품에 부착된 QR코드 또는 천호몰을 통해 각종 검사와 관련된 자료를 확인할 수 있습니다.
              </div>
            </div>
            <div className="img-style">
              <div className="img-inner">
                <img src={`https://img.chunhomall.com/images/brand_site/qualitysystem-section-13_600x400.jpg.jpg`} alt="Partner Image" />
                <div className="img-inner-text up">
                  검사성적서 공개
                </div>
              </div>
              <div className="img-text">
                원료부터 완제품까지 제품의 안전성을 확인할 수 있는 검사성적서를 천호몰에 공개하고 있습니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Qs;
